<template>
    <div class="index">
        <!-- banner -->
        <slider :sliderData="sliderData"></slider>
        <div class="margin-t40 margin-b40">
          <!-- 系部新闻（带图）+ 通知公告（无图）-->
          <div class="w1200 newListDiv flexDiv">
            <xbxw :xbxwList='xbxwList' moreLink = "/list.html?HType=2&CId=6747"></xbxw>
            <tzgg :tzggList='tzggList' moreLink = "/list.html?HType=2&CId=6748"></tzgg>
          </div>
          <!-- 实训中心 -->
          <div class="sxzxDiv margin-t50 margin-b50">
            <div class="sxzx">
              <div class="box">
                <a href="./list.html?HType=2&CId=6750&NId=120524"><img src="../assets/img/sxzx.png" alt=""></a>
                <em>TRAINING CENTER</em>
                <p>专业的实训中心，真实还原工作场景，让你每天都在进步</p>
              </div>
            </div>
          </div>
          <!-- 资料下载+图片展示 -->
          <div class="listSty margin-t50 margin-b50">
            <div class="w1200 flexDiv">
              <ul class="imgList flexDiv">
                <li>
                   <p><i>实践教学</i></p>
                </li>
                <li>
                  <a href="http://swjtuhc.cn/html/jdygd/list.html?HType=2&CId=6749&NId=87868"><em></em></a>
                  <p>考证培训</p>
                </li>
                <li>
                  <a href="http://swjtuhc.cn/html/jdygd/list.html?HType=2&CId=6749&NId=87870"><em></em></a>
                  <p>金工实习</p>
                </li>
                <li>
                  <a href="http://swjtuhc.cn/html/jdygd/list.html?HType=2&CId=6749&NId=87869"><em></em></a>
                  <p>特色工作室</p>
                </li>
              </ul>
              <div class="">
                <down :downList='downList' moreLink = "/list.html?HType=4&CId=6752"></down>
              </div>
            </div>
          </div>
          <!-- 教师风采 -->
          <yxfc :yxfcList='yxfcList' moreLink = "/list.html?HType=2&CId=6746"></yxfc>
        </div>
    </div>
</template>
<script>
import '../assets/css/index.css';
import slider from '@/components/slider';
import xbxw from '@/components/xbxw';
import tzgg from '@/components/tzgg';
import down from '@/components/down';
import yxfc from '@/components/yxfc';
export default {
    name:'index',
    components:{
      slider,
      xbxw,
      tzgg,
      down,
      yxfc
    },
    data(){
      return{
        baseUrl:'this.baseUrl',
        sliderData:[],
        xbxwList:[],
        tzggList:[],
        downList:[],
        yxfcList:[]
      }
    },
    created(){
        this.$root.$children['0'].$children['0'].menuListOne.forEach(element =>element.On = false)
        this.sliderData = this.Base.GetFilesInfoByCid(6753,1,'',6,1);
        this.xbxwList = this.Base.GetNewsInfoByCid(6747,true,1,'',1);
        this.tzggList = this.Base.GetNewsInfoByCid(6748,false,1,'',4);
        this.downList = this.Base.GetFilesInfoByCid(6752,1,'',4,1);
        this.yxfcList = this.Base.GetNewsInfoByCid(6746,true,1,'',3);
        // console.log(this.yxfcList);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/index.vue